import Card from '~/components/Card'
import Icon from '~/components/Icon'
import Input from '~/components/Input'
import Select from '~/components/Select'
import type { TabFormatosProps } from './types'

/** Pestaña Formatos: moneda, fechas, idioma y locales con los que se muestran números y fechas. */
function TabFormatos(props: TabFormatosProps) {
  const { form, currencyOptions } = props

  return (
    <Card>
      <Card.Title>
        <div class="flex items-center">
          <Icon icon="material-symbols-light:tune" size={20} class="mr-2" />
          <h2 class="text-xl font-semibold">Formatos</h2>
        </div>
      </Card.Title>
      <Card.Body>
        <div class="space-y-4">
          <Select name="currency" label="Moneda" value={(form.values().currency as string) ?? 'COP'} options={currencyOptions()} />
          <Select
            name="dateFormat"
            label="Formato de fecha"
            value={(form.values().dateFormat as string) ?? 'DD/MM/YYYY'}
            options={[
              { value: 'DD/MM/YYYY', title: 'DD/MM/YYYY' },
              { value: 'MM/DD/YYYY', title: 'MM/DD/YYYY' },
              { value: 'YYYY-MM-DD', title: 'YYYY-MM-DD' }
            ]}
          />
          <Select
            name="language"
            label="Idioma"
            value={(form.values().language as string) ?? 'es'}
            options={[
              { value: 'es', title: 'Español' },
              { value: 'en', title: 'Inglés' }
            ]}
          />
          <Input name="country" label="País por defecto" placeholder="CO" />
          <Input name="numberLocale" label="Locale de números" placeholder="es-CO" />
          <Input name="dateLocale" label="Locale de fechas" placeholder="es-CO" />
        </div>
      </Card.Body>
    </Card>
  )
}

export default TabFormatos
